var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "reportsModal",
            size: "xl",
            "content-class": "menu-bg-blue-transparent-modal dpr-reports-modal",
            title: "Daily Productivity Report",
            centered: "",
            "hide-footer": "",
          },
          on: {
            show: function ($event) {
              return _vm.initGraphs()
            },
          },
        },
        [
          _c(
            "b-container",
            [
              _c(
                "b-tabs",
                { attrs: { align: "center", pills: "", card: "" } },
                [
                  _c(
                    "b-row",
                    {
                      staticClass: "pt-3",
                      staticStyle: { width: "100%" },
                      attrs: {
                        "align-h": "center",
                        "align-v": "center",
                        "no-gutters": "",
                      },
                    },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "5" } },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btn btn-md",
                              attrs: { variant: _vm.dailyButtonClassCtrl },
                              on: {
                                click: function ($event) {
                                  return _vm.reportsFilterButtonSelected(
                                    "Daily"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n              Daily\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "btn btn-md",
                              attrs: { variant: _vm.weeklyButtonClassCtrl },
                              on: {
                                click: function ($event) {
                                  return _vm.reportsFilterButtonSelected(
                                    "Weekly"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n              Weekly\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "btn btn-md",
                              attrs: { variant: _vm.monthlyButtonClassCtrl },
                              on: {
                                click: function ($event) {
                                  return _vm.reportsFilterButtonSelected(
                                    "Monthly"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n              Monthly\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "btn btn-md",
                              attrs: { variant: _vm.quarterlyButtonClassCtrl },
                              on: {
                                click: function ($event) {
                                  return _vm.reportsFilterButtonSelected(
                                    "Quarterly"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n              Quarterly\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "btn btn-md",
                              attrs: { variant: _vm.yearlyButtonClassCtrl },
                              on: {
                                click: function ($event) {
                                  return _vm.reportsFilterButtonSelected(
                                    "Yearly"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n              Yearly\n            ")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.quarterlyInputCtrl
                        ? _c(
                            "b-col",
                            { staticClass: "pr-2", attrs: { cols: "2.5" } },
                            [
                              _c(
                                "b-select",
                                {
                                  staticClass: "form-control mx-1",
                                  attrs: { id: "quarterSelect" },
                                  on: {
                                    change: function ($event) {
                                      return _vm.refreshAllGraphs()
                                    },
                                  },
                                  model: {
                                    value: _vm.reportsSelectedQuarter,
                                    callback: function ($$v) {
                                      _vm.reportsSelectedQuarter = $$v
                                    },
                                    expression: "reportsSelectedQuarter",
                                  },
                                },
                                _vm._l(_vm.ReportQuarters, function (quarter) {
                                  return _c(
                                    "b-select-option",
                                    {
                                      key: quarter.id,
                                      attrs: {
                                        value: quarter.id,
                                        disabled: quarter.disabled,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(quarter.quarter) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.quarterlyInputCtrl
                        ? _c(
                            "b-col",
                            { staticClass: "px-2", attrs: { cols: "1.5" } },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.qYear,
                                    expression: "qYear",
                                  },
                                ],
                                staticClass: "form-control sm",
                                attrs: {
                                  type: "number",
                                  onKeyDown: "return false",
                                  placeholder: "year",
                                  min: 1999,
                                  max: _vm.maxQuarterYear,
                                },
                                domProps: { value: _vm.qYear },
                                on: {
                                  change: function ($event) {
                                    return _vm.clickEventQuarterlyYear()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.qYear = $event.target.value
                                  },
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.yearlyInputCtrl
                        ? _c(
                            "b-col",
                            { staticClass: "px-2", attrs: { cols: "1.5" } },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.yYear,
                                    expression: "yYear",
                                  },
                                ],
                                staticClass: "form-control sm",
                                attrs: {
                                  type: "number",
                                  onKeyDown: "return false",
                                  placeholder: "year",
                                  min: 1999,
                                  max: _vm.maxQuarterYear,
                                },
                                domProps: { value: _vm.yYear },
                                on: {
                                  change: function ($event) {
                                    return _vm.refreshAllGraphs()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.yYear = $event.target.value
                                  },
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.monthlyInputCtrl
                        ? _c(
                            "b-col",
                            { staticClass: "px-2", attrs: { cols: "2.5" } },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.reportsSelectedMonthYear,
                                    expression: "reportsSelectedMonthYear",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "month",
                                  id: "monthSelect",
                                  max: _vm.maxMonth,
                                },
                                domProps: {
                                  value: _vm.reportsSelectedMonthYear,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.refreshAllGraphs()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.reportsSelectedMonthYear =
                                      $event.target.value
                                  },
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.weeklyInputCtrl
                        ? _c(
                            "b-col",
                            { staticClass: "px-2", attrs: { cols: "2.5" } },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.reportsSelectedWeek,
                                    expression: "reportsSelectedWeek",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "week",
                                  id: "weekSelect",
                                  max: _vm.maxWeek,
                                },
                                domProps: { value: _vm.reportsSelectedWeek },
                                on: {
                                  change: function ($event) {
                                    return _vm.refreshAllGraphs()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.reportsSelectedWeek =
                                      $event.target.value
                                  },
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.dailyInputCtrl
                        ? _c(
                            "b-col",
                            { staticClass: "px-2", attrs: { cols: "2.5" } },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.reportsSelectedDay,
                                    expression: "reportsSelectedDay",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "date",
                                  id: "daySelect",
                                  max: _vm.currentDate,
                                },
                                domProps: { value: _vm.reportsSelectedDay },
                                on: {
                                  change: function ($event) {
                                    return _vm.refreshAllGraphs()
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.reportsSelectedDay = $event.target.value
                                  },
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "2.5" } },
                        [
                          _c(
                            "b-form-select",
                            {
                              staticClass: "form-control form-select row-input",
                              on: {
                                change: function ($event) {
                                  return _vm.refreshAllGraphs()
                                },
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "first",
                                  fn: function () {
                                    return [
                                      _c(
                                        "b-form-select-option",
                                        {
                                          attrs: { value: null, disabled: "" },
                                        },
                                        [_vm._v("-- Select Region --")]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                              model: {
                                value: _vm.dprRegion,
                                callback: function ($$v) {
                                  _vm.dprRegion = $$v
                                },
                                expression: "dprRegion",
                              },
                            },
                            [
                              _vm._v(" "),
                              _vm._l(_vm.dprExtents, function (prop, i) {
                                return _c(
                                  "b-form-select-option",
                                  { key: i, attrs: { value: prop.id } },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(prop.extent_description) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      attrs: { title: "Full Down Days", active: "" },
                      on: {
                        click: function ($event) {
                          return _vm.refreshAllGraphs()
                        },
                      },
                    },
                    [
                      _c(
                        "b-row",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.showFullDownDaysTabs && _vm.graphsReady,
                              expression: "showFullDownDaysTabs && graphsReady",
                            },
                          ],
                        },
                        [
                          _c("b-col", { staticClass: "text-center" }, [
                            _c("h5", [
                              _vm._v(
                                "\n                Number of reports with full down days:\n                " +
                                  _vm._s(_vm.numberOfFullDownDays) +
                                  "\n              "
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("b-row", { staticClass: "pb-2" }),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.showFullDownDaysTabs && _vm.graphsReady,
                              expression: "showFullDownDaysTabs && graphsReady",
                            },
                          ],
                          attrs: { "align-v": "center" },
                        },
                        [
                          _c(
                            "b-col",
                            [
                              _c("apexchart", {
                                ref: "downDaysPerSystemChart",
                                attrs: {
                                  height: "400px",
                                  type: "line",
                                  options: _vm.downDaysPerSystemOptions,
                                  series: _vm.downDaysPerSystemSeries,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("apexchart", {
                                ref: "fullDownTimeTypeChart",
                                attrs: {
                                  width: "100%",
                                  height: "auto",
                                  type: "donut",
                                  options: _vm.fullDownTimeTypeOptions,
                                  series: _vm.fullDownTimeTypeSeries,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.graphsReady
                        ? _c(
                            "b-row",
                            {
                              staticClass:
                                "d-flex justify-content-center align-items-center",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center align-items-center py-1",
                                },
                                [
                                  _c("span", {
                                    staticClass:
                                      "spinner-border spinner-border-md highlightLoader",
                                    attrs: {
                                      role: "status",
                                      "aria-hidden": "true",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "highlightLoader p-1 spinner-border-md",
                                    },
                                    [_vm._v("Loading Data...")]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : !_vm.showFullDownDaysTabs
                        ? _c(
                            "b-row",
                            {
                              staticClass:
                                "d-flex justify-content-center align-items-center",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center align-items-center py-1",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "highlightLoader p-1 spinner-border-md",
                                    },
                                    [_vm._v("No Data Available")]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      attrs: { title: "Partial Down Days" },
                      on: {
                        click: function ($event) {
                          return _vm.refreshAllGraphs()
                        },
                      },
                    },
                    [
                      _c(
                        "b-row",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.showPartialDownDaysTabs && _vm.graphsReady,
                              expression:
                                "showPartialDownDaysTabs && graphsReady",
                            },
                          ],
                        },
                        [
                          _c("b-col", { staticClass: "text-center" }, [
                            _c("h5", [
                              _vm._v(
                                "\n                Number of reports with partial downtime:\n                " +
                                  _vm._s(_vm.numberOfPartialDownTimeEntries) +
                                  "\n              "
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.showPartialDownDaysTabs && _vm.graphsReady,
                              expression:
                                "showPartialDownDaysTabs && graphsReady",
                            },
                          ],
                          staticClass: "pb-2",
                        },
                        [
                          _c("b-col", { staticClass: "text-center" }, [
                            _c("h5", [
                              _vm._v(
                                "\n                Total partial downtime hours:\n                " +
                                  _vm._s(_vm.totalPartialHoursDownTime) +
                                  "\n              "
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.showPartialDownDaysTabs && _vm.graphsReady,
                              expression:
                                "showPartialDownDaysTabs && graphsReady",
                            },
                          ],
                          attrs: { "align-v": "center" },
                        },
                        [
                          _c(
                            "b-col",
                            [
                              _c("apexchart", {
                                ref: "partialDownDaysBySystemByTypeChart",
                                attrs: {
                                  height: "400px",
                                  type: "line",
                                  options:
                                    _vm.partialDownDaysBySystemByTypeOptions,
                                  series:
                                    _vm.partialDownDaysBySystemByTypeSeries,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("apexchart", {
                                ref: "partialDownTimeTypeChart",
                                attrs: {
                                  height: "auto",
                                  type: "donut",
                                  options: _vm.partialDownTimeTypeOptions,
                                  series: _vm.partialDownTimeTypeSeries,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.graphsReady
                        ? _c(
                            "b-row",
                            {
                              staticClass:
                                "d-flex justify-content-center align-items-center",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center align-items-center py-1",
                                },
                                [
                                  _c("span", {
                                    staticClass:
                                      "spinner-border spinner-border-md highlightLoader",
                                    attrs: {
                                      role: "status",
                                      "aria-hidden": "true",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "highlightLoader p-1 spinner-border-md",
                                    },
                                    [_vm._v("Loading Data...")]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : !_vm.showPartialDownDaysTabs
                        ? _c(
                            "b-row",
                            {
                              staticClass:
                                "d-flex justify-content-center align-items-center",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center align-items-center py-1",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "highlightLoader p-1 spinner-border-md",
                                    },
                                    [_vm._v("No Data Available")]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      attrs: { title: "Collection" },
                      on: {
                        click: function ($event) {
                          return _vm.refreshAllGraphs()
                        },
                      },
                    },
                    [
                      _c(
                        "b-row",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showCollectionTabs && _vm.graphsReady,
                              expression: "showCollectionTabs && graphsReady",
                            },
                          ],
                          attrs: { "align-v": "center" },
                        },
                        [
                          _c(
                            "b-col",
                            [
                              _c("apexchart", {
                                ref: "daysCollectedByOperatorChart",
                                attrs: {
                                  height: "400px",
                                  type: "bar",
                                  options: _vm.daysCollectedByOperatorOptions,
                                  series: _vm.daysCollectedByOperatorSeries,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("apexchart", {
                                ref: "operatorDaysPerYearChart",
                                attrs: {
                                  height: "auto",
                                  type: "bar",
                                  options: _vm.operatorDaysPerYearOptions,
                                  series: _vm.operatorDaysPerYearSeries,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.graphsReady
                        ? _c(
                            "b-row",
                            {
                              staticClass:
                                "d-flex justify-content-center align-items-center",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center align-items-center py-1",
                                },
                                [
                                  _c("span", {
                                    staticClass:
                                      "spinner-border spinner-border-md highlightLoader",
                                    attrs: {
                                      role: "status",
                                      "aria-hidden": "true",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "highlightLoader p-1 spinner-border-md",
                                    },
                                    [_vm._v("Loading Data...")]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : !_vm.showCollectionTabs
                        ? _c(
                            "b-row",
                            {
                              staticClass:
                                "d-flex justify-content-center align-items-center",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center align-items-center py-1",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "highlightLoader p-1 spinner-border-md",
                                    },
                                    [_vm._v("No Data Available")]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      attrs: { title: "Vehicle Hours" },
                      on: {
                        click: function ($event) {
                          return _vm.refreshAllGraphs()
                        },
                      },
                    },
                    [
                      _c(
                        "b-row",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showHoursTabs && _vm.graphsReady,
                              expression: "showHoursTabs && graphsReady",
                            },
                          ],
                          attrs: { "align-v": "center" },
                        },
                        [
                          _c(
                            "b-col",
                            [
                              _c("apexchart", {
                                ref: "hoursBySystemByTypeChart",
                                attrs: {
                                  width: "100%",
                                  height: "400px",
                                  type: "line",
                                  options: _vm.hoursBySystemByTypeOptions,
                                  series: _vm.hoursBySystemByTypeSeries,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("apexchart", {
                                ref: "totalHoursTypeChart",
                                attrs: {
                                  height: "auto",
                                  options: _vm.hoursTypeOptions,
                                  series: _vm.hoursTypeSeries,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showHoursTabs && _vm.graphsReady,
                              expression: "showHoursTabs && graphsReady",
                            },
                          ],
                          staticClass:
                            "w-100 p-2 dflex justify-content-center align-items-center",
                          attrs: { "no-gutters": "" },
                        },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass:
                                "w-auto pl-4 text-center dpr-hours-note",
                            },
                            [
                              _vm._v(
                                "** Total Hours = Truck Hours + Office Hours **"
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.graphsReady
                        ? _c(
                            "b-row",
                            {
                              staticClass:
                                "d-flex justify-content-center align-items-center",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center align-items-center py-1",
                                },
                                [
                                  _c("span", {
                                    staticClass:
                                      "spinner-border spinner-border-md highlightLoader",
                                    attrs: {
                                      role: "status",
                                      "aria-hidden": "true",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "highlightLoader p-1 spinner-border-md",
                                    },
                                    [_vm._v("Loading Data...")]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : !_vm.showHoursTabs
                        ? _c(
                            "b-row",
                            {
                              staticClass:
                                "d-flex justify-content-center align-items-center",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center align-items-center py-1",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "highlightLoader p-1 spinner-border-md",
                                    },
                                    [_vm._v("No Data Available")]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      attrs: { title: "Operator Hours" },
                      on: {
                        click: function ($event) {
                          return _vm.refreshAllGraphs()
                        },
                      },
                    },
                    [
                      _c(
                        "b-row",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.showOperatorHoursTabs && _vm.graphsReady,
                              expression:
                                "showOperatorHoursTabs && graphsReady",
                            },
                          ],
                          attrs: { "align-v": "center" },
                        },
                        [
                          _c(
                            "b-col",
                            [
                              _c("apexchart", {
                                ref: "hoursByOperatorsByTypeChart",
                                attrs: {
                                  width: "100%",
                                  height: "400rem",
                                  type: "line",
                                  options: _vm.hoursByOperatorsByTypeOptions,
                                  series: _vm.hoursByOperatorsByTypeSeries,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("apexchart", {
                                ref: "totalOperatorsHoursTypeChart",
                                attrs: {
                                  height: "auto",
                                  options: _vm.hoursTypeOperatorsOptions,
                                  series: _vm.hoursTypeOperatorsSeries,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.showOperatorHoursTabs && _vm.graphsReady,
                              expression:
                                "showOperatorHoursTabs && graphsReady",
                            },
                          ],
                          staticClass:
                            "w-100 p-2 dflex justify-content-center align-items-center",
                          attrs: { "no-gutters": "" },
                        },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass:
                                "w-auto pl-4 text-center dpr-hours-note",
                            },
                            [
                              _vm._v(
                                "** Total Hours = Truck Hours + Office Hours **"
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.graphsReady
                        ? _c(
                            "b-row",
                            {
                              staticClass:
                                "d-flex justify-content-center align-items-center",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center align-items-center py-1",
                                },
                                [
                                  _c("span", {
                                    staticClass:
                                      "spinner-border spinner-border-md highlightLoader",
                                    attrs: {
                                      role: "status",
                                      "aria-hidden": "true",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "highlightLoader p-1 spinner-border-md",
                                    },
                                    [_vm._v("Loading Data...")]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : !_vm.showOperatorHoursTabs
                        ? _c(
                            "b-row",
                            {
                              staticClass:
                                "d-flex justify-content-center align-items-center",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center align-items-center py-1",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "highlightLoader p-1 spinner-border-md",
                                    },
                                    [_vm._v("No Data Available")]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }